
import classes from './BackdropBlur.module.css'

/**
 * BackdropBlur component for modal overlays
 * @param {Object} props - Component props
 * @param {string} [props.variant='heavy'] - Backdrop variant: 
 *   - 'heavy' (default): High z-index (9999) for message boxes/popups
 *   - 'modal': Lower z-index (20) for regular modals to allow fixed bars above
 *   - 'light': Lighter blur and opacity (can combine with other variants)
 * @param {string} [props.className] - Additional CSS classes
 * @param {React.ReactNode} props.children - Modal content
 */
const BackdropBlur = (props) => {
    const variant = props.variant || 'heavy' // Default to heavy blur for backward compatibility
    
    return (
        <div className={`${classes.backdrop} ${classes[variant]} ${props.className || ''}`}>
            {props.children}
        </div>
    )
}

export default BackdropBlur